import React, { useEffect, useState } from "react";
import "./DataEngineeringFoundTrack.css";
import AutomationEngineeringFoundationLearnPathData from "../../data/AutomationEngineeringFoundationLearnPathData.json";
import { CircularProgress, Typography, Box } from "@mui/material";
import "./WebDeveloperFoundTrack.css";
import { useMsal } from "@azure/msal-react";
import { Coursesdata } from "../../Redux/CoursesUpload";
import { useSelector, useDispatch } from "react-redux";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import Alert from '@mui/material/Alert';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: "100%",
  // position: "relative",
  borderRadius: 3,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 2,
    backgroundColor: theme.palette.mode === "light" ? "#460073" : "#f1f1f1",
  },
}));
function AutomationEngineeringFoundTrack() {

  const dispatch = useDispatch();
  const getCoursesData = useSelector(
    (state) => state.coursesData.CoursesUploadData.filter((course) => course.tableName === "Automation_Engineer_Beginner" && course.data)
  );
  const CoursesData = getCoursesData.flatMap((item) => item.data)

  const coursesError = useSelector((state) => state.coursesData.error);
  console.log(coursesError, "courses error");

  useEffect(() => {
    var acc = document.getElementsByClassName("accordion");
    var i = 0;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }, []);
  useEffect(() => {
    dispatch(Coursesdata());
  }, []);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let username = activeAccount.username;
  const currUserData = CoursesData.filter(
    (item) => item["Email address"] === username
  );
  const coursesList = AutomationEngineeringFoundationLearnPathData.learnings.map(
    (course) => {
      const userData = currUserData[0];

      const isCompleted = course.learnpaths.map(
        (path) => userData && userData[path] === "Completed"
      );
      if (!isCompleted && currUserData.length === 0) {
        return { ...course, completePercentage: 0 };
      }
      // Calculate completion percentage if all learnpaths are completed
      const completedLearnpaths =
        userData &&
        course.learnpaths.filter((path) => userData[path] === "Completed")
          .length;
      const completePercentage = Number(
        ((completedLearnpaths / course.learnpaths.length) * 100).toFixed(2)
      );
      return { ...course, completePercentage };
    }
  );
  const completionCourses = coursesList.reduce(
    (acc, cur) => acc + cur.completePercentage,
    0
  );
  const totalPercentage = completionCourses / coursesList.length;

  const updatedCourses = coursesList.map((item) => ({
    ...item,
    overalCompleted: totalPercentage,
  }));
  return (
    <>
    {coursesError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
      <div className="data-engi-found-track-wrap">
        <div className="data-engi-found-track-row row1">
          <div className="track-card-wrap">
            <div className="track-card-row row1">
              <h3>Junior(P1) Courses</h3>
            </div>
            <div className="track-card-row row2">
              <div className="hours-glass-wrap">
                <div className="hours-glass-row">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/DataEngineering/Hourglass.png"
                    }
                    //src="images/DataEngineering/Hourglass.png"
                    alt="Hour"
                    className="hour-glass"
                  />
                </div>
                <div className="hours-glass-row">
                  <p>
                    Duration <span>60 Hours</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div style={{ position: "relative", height: "20px" }}>
            <BorderLinearProgress
              variant="determinate"
              value={totalPercentage > 0 ? Math.round(totalPercentage) : 0}
            />
            <Typography
              variant="h6"
              style={{
                position: "absolute",
                top: "50%",
                left: "20%",
                fontSize: "14px",
                transform: "translate(-50%, -50%)",
                zIndex: 1, // Ensures the text is above the progress bar
              }}
              sx={totalPercentage < 14 ? { color: "#460073" } : totalPercentage < 21 ? { color: "#fd7e14" }
                : { color: "#fff" }
              }            >
              {totalPercentage && totalPercentage > 0
                ? Math.round(totalPercentage) + "%"
                : 0 + "%"}
            </Typography>
          </div>
          <span className="overall-text">Overall Completed</span>
          <div className="found-track-card-box">
            <a
              //href="https://app.pluralsight.com/id/signin?redirectTo=https://app.pluralsight.com/channels/details/ef40e40e-3cdf-4885-9395-febd911870e4"
              href="https://deepknowledge.accenture.com/course/view.php?id=1168"
            // target="_blank"
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/DataEngineering/found-track-card.png"
                }
                //src="images/DataEngineering/found-track-card.png"
                alt="foundation"
                className="found-track-card"
              />
            </a>
          </div>
        </div>
        <div className="data-engi-found-track-row row2">
          <div className="tracks-acc-wrap">
            {CoursesData != "" && updatedCourses != [] && currUserData.length > 0
              ? updatedCourses.map((item, index) => {
                return (
                  <>
                    <div className="tracks-acc-row">
                      <div className="tracks-acc-box">
                        <button className="accordion">
                          <p>{item.learnhead}</p>
                          <span className="learn-details">
                            ({item.learnhours})
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                              }}
                              className="circleContainer"
                            >
                              <CircularProgress
                                sx={{
                                  height: "30px !important",
                                  width: "30px !important",
                                  zIndex: "1",
                                  strokeLinecap: "round",
                                }}
                                className="innerbg1"
                                thickness={7}
                                // size={20}
                                // determinate
                                // variant="determinate"
                                variant="determinate"
                                value={item.completePercentage}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "white",
                                  borderRadius: "50%",
                                  height: "30px",
                                  width: "30px",
                                  backgroundColor: "#e0e0e0",
                                  // padding: "5px",
                                }}
                                className="progressAndDuration1"
                              >
                                <Typography
                                  className="innerBorder1"
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  <span className="completionNum">{`${Math.round(
                                    item.completePercentage
                                  )}%`}</span>
                                </Typography>
                              </Box>
                            </Box>
                          </span>
                        </button>
                        <div className="panel">
                          <ul>
                            {item.learnpaths.map((item1, index) => {
                              return (
                                <li>
                                  <a
                                    //href="https://app.pluralsight.com/id/signin?redirectTo=https://app.pluralsight.com/channels/details/ef40e40e-3cdf-4885-9395-febd911870e4"
                                    //href="#"
                                    href="https://deepknowledge.accenture.com/course/view.php?id=1168"
                                  // target="_blank"
                                  >
                                    {item1}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })
              : AutomationEngineeringFoundationLearnPathData.learnings.map(
                (item, index) => {
                  return (
                    <>
                      <div className="tracks-acc-row">
                        <div className="tracks-acc-box">
                          <button className="accordion">
                            <p>{item.learnhead}</p>
                            <span>({item.learnhours})</span>
                          </button>
                          <div className="panel">
                            <ul>
                              {item.learnpaths.map((item1, index) => {
                                return (
                                  <li>
                                    <a
                                      //href="https://app.pluralsight.com/id/signin?redirectTo=https://app.pluralsight.com/channels/details/ef40e40e-3cdf-4885-9395-febd911870e4"
                                      //href="#"
                                      href="https://deepknowledge.accenture.com/course/view.php?id=1168"
                                    // target="_blank"
                                    >
                                      {item1}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                }
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AutomationEngineeringFoundTrack;
